export default "ALTER TABLE `subcategories` ADD `seed_name` text;";